import waitForSentry from 'Helpers/Sentry/wait-for-sentry';

let translations = {};

const fetchTranslations = async (url) => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to load translations from ${url}: ${response.status}`);
  }
  return response.json();
};

/**
 * Load the current language's strings from the URL set (and preloaded) in index.html.
 * English uses the default messages, so has no URL. Falls back to English if the request fails.
 * @return {Promise<Object>}
 */
export const loadTranslations = async () => {
  const url = window.translationsUrl;

  if (!url) {
    return translations;
  }

  try {
    translations = await fetchTranslations(url).catch(() => fetchTranslations(url));
  } catch (ex) {
    waitForSentry((Sentry) => {
      Sentry.captureException(ex);
    });
  }

  return translations;
};

/**
 * Strings loaded by loadTranslations
 * @return {Object}
 */
export const getTranslations = () => translations;
